<h4 class="card-title">Grupos de pruebas <button class="btn btn-info waves-effect btn-sm btn-rounded" [routerLink]="['/dashboard/create-test-group']">Crear nuevo</button></h4>

<table class="tests-table table" >
    <thead>
        <tr>
            <th >Nombre</th>
            <th *ngIf="user && user.role == 'admin'" >Activo</th>
            <th class="text-center" >Editar/Borrar</th>
        </tr>
    </thead>
    
    <tbody>
        <tr *ngFor="let group of groups; index as i">
            <td >{{group.title}}</td>
            <td *ngIf="user && user.role == 'admin'" class="footable-visible pointer" (click)="toggleVisibility(group)" ><b>{{group.active ? 'SI' : 'NO'}}</b></td>
            <td class="footable-visible footable-last-column text-center">
                <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " [routerLink]="['/dashboard/create-test-group']" [queryParams]="{editingId: group._id}" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDelete(group._id)" ><i class="fa fa-eraser" ></i></button>
            </td>
        </tr>
    </tbody>

</table>